import React, { Component } from "react";

class Table extends Component {
  render() {
    return (
      <div>
        TABLES GOES HERE
      </div>
    );
  }
}

export default Table;
